import { useQuery } from "@tanstack/react-query";
import { USER_IP_ENDPOINT } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchUser = () => {
  return useQuery({
    queryKey: ["user"],
    queryFn: () => fetcher(USER_IP_ENDPOINT),
    select: (response) => response?.data ?? response ?? null,
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: false,
  });
};
